module.exports = __webpack_public_path__ + "img/newt7.dcea2641.png";